import { intlnumberFormat } from '@patrianna/shared-utils/numbers'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/page-vip.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  currentVipPoints: number
  threshold: number
  nextLevelName: string
}

function Information(props: Props) {
  const { currentVipPoints, threshold, nextLevelName } = props

  return (
    <div className={classes.root}>
      <p className='mt-typography-body2'>
        <b className={classes.caption}>{t('info_caption1')}:</b>
        {intlnumberFormat(currentVipPoints, 'en-US')}
      </p>
      <p className='mt-typography-body2'>
        <b className={classes.caption}>
          {t('info_caption2_prt1')} {nextLevelName} {t('info_caption2_prt2')}
        </b>
        {intlnumberFormat(threshold - currentVipPoints, 'en-US')}
      </p>
    </div>
  )
}

export default Information
